import React from 'react';
import { Modal } from 'react-bootstrap';
import { Digital } from 'react-activity';

import styles from './css/ActivityLoader.module.css';
import "react-activity/dist/library.css";

/**
 * `overModal` lifts the loader and its backdrop above Bootstrap's modal layer
 * (1040/1050) so it stays visible, and dims the page, while another modal is open.
 */
const ActivityLoader = (props) => (
  <Modal
    id="activityModal"
    show={props.show}
    centered
    className={[
      props.uploadComp ? styles.uploadContainer : styles.modalContainer,
      props.overModal ? styles.overModal : '',
    ].join(' ')}
    backdropClassName={props.overModal ? styles.overModalBackdrop : undefined}
    onHide={() => {}}
  >
    <Digital size={50} color="#ffffff" />
  </Modal>
);

export default ActivityLoader;
